@if (isApplicable()) {
<ul class="list-unstyled mb-0">
  @if (redirectStatus === 'cancel') {
  <ish-error-message [error]="{ message: 'shopping_cart.payment.canceled.text' | translate }" />
  } @if (redirectStatus === 'failure') {
  <ish-error-message
    [error]="{
      message: ('checkout.payment.sorry_message.text' | translate) + ' ' + ('checkout.payment.failed.text' | translate)
    }"
  />
  }
  <!-- container for displaying of fast checkout payment methods -->
  @if (paymentMethods$ | async; as paymentMethods) {
   @if(paymentMethods.length){
  <li class="d-block text-center p-2">{{ 'shopping_cart.payment.or.text' | translate }}</li>
  @for (paymentMethod of paymentMethods; track paymentMethod) {
  <li class="d-block">
    <button
      type="button"
      (click)="fastCheckout(paymentMethod.id)"
      class="btn btn-lg btn-block btn-secondary"
      [disabled]="paymentMethod.isRestricted"
    >
      {{ paymentMethod.displayName }}
    </button>
    <!-- payment cost information -->
    <ish-basket-payment-cost-info
      [basket]="basket()"
      [paymentMethod]="paymentMethod"
      [priceType]="priceType$ | async"
    />
  </li>
    } 
   }
  }
</ul>
}
